import styled, { css } from 'styled-components'

export const Container = styled.div<{ $fill?: boolean }>`
  width: 100%;
  margin-bottom: 20px;

  ${({ $fill }) => $fill && css`
    height: 100%;
    margin-bottom: 0;
  `}
`;

export const Title = styled.h2`
  margin: 0 0 10px 10px;
  font-size: 24px;
  font-weight: 600;
  color: #333;
  justify-self: center;
`;

export const PanoramaWrapper = styled.div<{ $pseudoFullscreen?: boolean; $fill?: boolean }>`
  position: relative;
  width: 100%;

  ${({ $fill }) => $fill && css`
    height: 100%;
  `}

  ${({ $pseudoFullscreen }) => $pseudoFullscreen && css`
    position: fixed;
    inset: 0;
    width: 100vw;
    height: 100vh;
    z-index: 1000;
  `}
`;

export const ViewerContainer = styled.div<{ $pseudoFullscreen?: boolean; $fill?: boolean }>`
  width: 100%;
  height: 300px;
  max-width: 100%;
  background: #000;

  ${({ $pseudoFullscreen, $fill }) => ($pseudoFullscreen || $fill) && css`
    height: 100%;
  `}
`

export const RecenterButton = styled.button`
  position: absolute;
  top: 124px;
  left: 4px;

  width: 26px;
  height: 26px;
  padding: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 15px;
  line-height: 1;
  font-family: Arial, sans-serif;
  color: #000;

  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.4);
  border-radius: 3px;

  cursor: pointer;
  z-index: 15;
`;

export const PseudoFullscreenButton = styled.button`
  position: absolute;
  top: 96px;
  left: 4px;

  width: 26px;
  height: 26px;
  padding: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 15px;
  line-height: 1;
  font-family: Arial, sans-serif;
  color: #000;

  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.4);
  border-radius: 3px;

  cursor: pointer;
  z-index: 15;
`;
